module.exports = __webpack_public_path__ + "img/header.53bcb4f4.png";